import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';

import Dialog from 'components/Dialog';
import AcceptTosForm from 'components/Login/AcceptTosForm';
import LoginForm from 'components/Login/LoginForm';
import { AppContext } from 'context';
import Layout from 'pages/Login/Layout';
import { DialogWidth, UserRole } from 'types';
import { colors } from 'theme';

const useStyles = makeStyles(() => ({
  link: {
    textTransform: 'uppercase',
    fontSize: '0.75rem',
    textDecoration: 'underline',
    color: colors.neutral800,
  },
  linkContainer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
  },
  separator: {
    borderRight: `1px solid ${colors.neutral800}`,
    paddingRight: 7,
    marginRight: 7,
  },
}));

const Login: React.FC = () => {
  const context = useContext(AppContext);
  const { t } = useTranslation();
  const classes = useStyles();

  const [tosModalDisplay, setTosModalDisplay] = useState<boolean>(false);
  useEffect(() => {
    setTosModalDisplay(!!context.user && !context.user.roles.includes(UserRole.ROLE_ACCEPTED_TOS));
  }, [context]);

  return (
    <>
      <Layout title={t('loginForm.title')}>
        <Dialog
          closable={false}
          renderButton={() => {}}
          isOpen={tosModalDisplay}
          width={DialogWidth.DETAILS}
          renderContent={() => <AcceptTosForm />}
        />
        <LoginForm />
      </Layout>
      <div className={classes.linkContainer}>
        <Link
          to="/politique-de-confidentialite.pdf"
          target="_blank"
          download
          className={`${classes.link} ${classes.separator}`}
        >
          {t('privacyPolicy')}
        </Link>
        <Link to="/cgu.pdf" target="_blank" download className={classes.link}>
          {t('termsOfUse')}
        </Link>
      </div>
    </>
  );
};
export default Login;
